import { ActionPanel } from "../../components/action-panel/action-panel";
import styles from "./home.module.scss";

export default function Home() {
  return (
    <div>
      <ActionPanel />
      <div>
        <h1 className={`${styles["header"]}`}>Key Account Approvals</h1>
      </div>
    </div>
  );
}
